// extracted by mini-css-extract-plugin
export var languageSwitcher = "language-switcher-module--language-switcher--7zGPE";
export var languageLink = "language-switcher-module--language-link--eKzrl";
export var languageIcon = "language-switcher-module--language-icon--2fbWF";